import React from "react";
import Reveal from "./Reveal";
import { strengthBlocks } from "../mock";

const StrengthBlocks = () => {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E4545F]">
            Why Continex
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#0F2A4A] md:text-4xl">
            Experience. Connections. Execution.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {strengthBlocks.map((b, i) => (
            <Reveal key={b.id} delay={i * 120}>
              <article className="group h-full overflow-hidden rounded-2xl bg-white shadow-[0_10px_40px_-20px_rgba(15,42,74,0.35)] transition-shadow duration-300 hover:shadow-[0_24px_60px_-24px_rgba(15,42,74,0.45)]">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={b.image}
                    alt={b.label}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0b2038]/70 to-transparent" />
                  <span className="absolute bottom-4 left-5 text-xs font-semibold uppercase tracking-[0.22em] text-white">
                    {b.label}
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="text-xl font-semibold leading-snug text-[#0F2A4A]">
                    {b.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
                    {b.text}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrengthBlocks;
